import { apiGet, apiPost, apiPut, apiDelete, invalidateApiReads } from 'utils/apiClient';
import type {
  Operation,
  DerivedPosition,
  AddOperationPayload,
  UpdateOperationPayload,
} from 'types/Portfolio';

const base = (username: string) => `/portfolio/${username}`;

export interface GetPortfolioResponse {
  operations: Operation[];
  positions: DerivedPosition[];
}

export interface OperationResponse {
  operation: Operation;
}

export interface DeleteOperationResponse {
  message?: string;
  success?: boolean;
}

async function getPortfolio(username: string): Promise<GetPortfolioResponse> {
  const res = await apiGet<GetPortfolioResponse>(`${base(username)}/portfolio`);
  return res ?? { operations: [], positions: [] };
}

async function addOperation(
  username: string,
  payload: AddOperationPayload
): Promise<OperationResponse> {
  const response = await apiPost<OperationResponse>(`${base(username)}/operations`, payload);
  invalidateApiReads(`${base(username)}/portfolio`);
  return response;
}

async function updateOperation(
  username: string,
  operationId: string,
  payload: UpdateOperationPayload
): Promise<OperationResponse> {
  const response = await apiPut<OperationResponse>(`${base(username)}/operations/${operationId}`, payload);
  invalidateApiReads(`${base(username)}/portfolio`);
  return response;
}

async function deleteOperation(
  username: string,
  operationId: string
): Promise<DeleteOperationResponse> {
  const response = await apiDelete<DeleteOperationResponse>(`${base(username)}/operations/${operationId}`);
  invalidateApiReads(`${base(username)}/portfolio`);
  return response;
}

export { getPortfolio, addOperation, updateOperation, deleteOperation };
